<template>
<div class="chapter">
<div class="inner_page">
<p class="cover"><img alt="Front Cover of 90 Days to Stress-Free" src="images/9780825463976_cover.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 000_Cover.vue?7fccfc2a